module.exports = __webpack_public_path__ + "media/uitx2.c06936e7.mp4";